import Vue from 'vue'
import App from './App.vue'

import moment from 'moment'
import VueModal from 'vue2-modal'
import VueMoment from 'vue-moment'
import VueLocalStorage from 'vue-localstorage'

require('moment/locale/ru')

Vue.use(VueModal)
Vue.use(VueLocalStorage)
Vue.use(VueMoment, { moment })

const app = new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/app.js